<template>
  <div>
    <v-dialog class="c-cover-dialog" v-model="open" persistent scrollable max-width="860px">
      <v-card>
        <v-card-title>
          <span>{{ $T('common.form.select_cover') }}</span>
          <v-spacer></v-spacer>
          <span class="c-count" :class="{ err: maxOriginalCount < getOriginalCount() }"
            >{{ $T('common.cover.original.count') }} [ {{ getOriginalCount() }} / {{ maxOriginalCount }} ]</span
          >
        </v-card-title>

        <v-divider />

        <v-card-text>
          <div class="circle c-cover-dialog c-dark">
            <div class="c-pv-area">
              <c-img :src="currentImg.src" class="l" />
              <c-img v-if="!leTbS" :src="currentImg.src" class="m" />
              <c-img v-if="!leTbS" :src="currentImg.src" class="s" />
            </div>
            <div class="c-r">
              <div class="imgs" :style="imgsStyle">
                <div class="c-img-item">
                  <label v-ripple class="c-inside">
                    <input
                      ref="comminCropFileInput"
                      id="cropFile"
                      type="file"
                      accept="image/*"
                      @change="handleFileSelect"
                      hidden
                    />
                    <c-img src="/imgs/covers/picture.png" />
                  </label>
                </div>
                <div
                  class="c-img-item"
                  :class="{ selected: img.id == currentImg.id }"
                  v-for="img in imgs"
                  :key="img.id"
                >
                  <label class="c-inside">
                    <a v-ripple class="c-main-img">
                      <c-img :src="img.src" />
                      <c-img
                        v-if="img.id != currentImg.id"
                        class="c-filter"
                        src="/imgs/dot.gif"
                        @click="selectImg(img.id)"
                      />
                    </a>
                    <c-img v-if="img.id == currentImg.id" class="c-checked" src="/imgs/covers/check.png" />
                    <a v-else-if="!img.id.startsWith('/imgs/')" v-ripple class="c-del-a">
                      <c-img
                        class="c-del circle"
                        v-if="!img.src.startsWith('/imgs/')"
                        src="/imgs/covers/delete.png"
                        @click="onClickDelete(img.id)"
                      />
                    </a>
                  </label>
                </div>
                <div class="c-clear"></div>
              </div>
              <div class="c-errmsg" v-if="maxOriginalCount < getOriginalCount()">
                {{ $T('common.cover.over.max', { c: maxOriginalCount }) }}
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="clr-btn"
            flat
            @click.native="save"
            :loading="loading"
            :disabled="maxOriginalCount < getOriginalCount()"
            >{{ $T('button.ok') }}</v-btn
          >
          <v-btn color="clr-btn-cancel" flat @click.native="cancel">{{ $T('button.cancel') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <crop
      v-if="crop.dialog"
      ref="crop-dialog"
      :size="size"
      :quality="quality"
      :dataUrl="crop.data"
      :dataExif="crop.exif"
      @cancel="closeCrop"
      @save="addNewCrop"
    />
  </div>
</template>

<script>
import crop from '../common/Crop.vue';

export default {
  props: {
    srcImgs: { type: Array, required: true },
    selectedPath: { type: String, required: true },
    deletedSrcImgs: { type: Array, required: false },
    maxOriginalCount: { type: Number, required: true },
    imgSize: { type: Number, required: false },
    imgQuality: { type: Number, required: false },
  },
  components: {
    crop: crop,
  },
  data() {
    return {
      open: true,
      size: this.imgSize ? this.imgSize : 160,
      quality: this.imgQuality ? this.imgQuality : 0.9,
      loading: false,
      currentImg: this.getCurrentImg(this.srcImages(), this.selectedPath),
      imgs: this.srcImages(),
      deleteImgs: this.deletedSrcImgs ? this.deletedSrcImgs : [],
      crop: {
        dialog: false,
        src: null,
      },
    };
  },
  created() {
    let uploadRegex = /^n-/;
    if (this.selectedPath.match(uploadRegex)) {
      // selected is object
      let selected = this.imgs.find(img => img.id === this.selectedPath);
      this.currentImg = {
        id: selected.id,
        src: selected.src,
      };
    } else {
      this.currentImg = {
        // selected is link
        id: this.selectedPath,
        src: this.selectedPath,
      };
    }
  },
  computed: {
    imgsStyle() {
      if (!this.leTbS) return {};
      var w = this.$store.state.tools.windowWidth;
      w -= 58;
      return { width: w - (w % 100) + 'px' };
    },
  },
  methods: {
    srcImages() {
      let deleted = this.deletedSrcImgs ? this.deletedSrcImgs : [];
      let imgs = [];
      for (let idx in this.srcImgs) {
        //          if(this.srcImgs[idx].id){ // is object
        //            imgs.push({id: this.srcImgs[idx].id, src: this.srcImgs[idx].src});
        //          } else { // is path
        //            imgs.push({id: this.srcImgs[idx], src: this.srcImgs[idx]});
        //          }

        if (typeof this.srcImgs[idx] === 'string') {
          if (deleted.indexOf(this.srcImgs[idx]) === -1) {
            imgs.push({ id: this.srcImgs[idx], src: this.srcImgs[idx] });
          }
        } else {
          if (deleted.indexOf(this.srcImgs[idx].id) === -1) {
            imgs.push({ id: this.srcImgs[idx].id, src: this.srcImgs[idx].src });
          }
        }
      }
      return imgs;
    },
    getOriginalCount() {
      if (!this.imgs) return 0;
      var count = 0;
      this.imgs.some(function(img, i) {
        if (!img.id.startsWith('/imgs/')) count++;
      });
      return count;
    },
    onClickDelete(id) {
      if (id.startsWith('n-')) {
        this.deleteImg(id);
        return;
      }

      this.$emit('delete', this, this.imgs, id);
    },
    deleteImg(id) {
      var imgs = this.imgs;
      this.imgs.some(function(img, i) {
        if (img.id == id) imgs.splice(i, 1);
      });
      if (!id.startsWith('n-') && !id.startsWith('/imgs/')) {
        this.deleteImgs.push(id);
      }
    },
    cancelDeleteImg(id) {},
    handleFileSelect: function(evt) {
      var files = evt.target.files; // FileList object

      if (files.length != 1) {
        console.error('selected file length is not 1');
        return;
      }
      var f = files[0];
      if (!f.type.match('image.*')) {
        console.error('file type does not match with image!');
        return;
      }

      var _this = this;
      var _crop = this.crop;

      var reader = new FileReader();
      // Closure to capture the file information.
      reader.onload = (function(theFile) {
        return function(e) {
          console.log(e.target.result.length);
          _crop.data = e.target.result;
          _crop.dialog = true;
          _this.$refs.comminCropFileInput.value = '';
        };
      })(f);
      // Read in the image file as a data URL.
      reader.readAsDataURL(f);
    },
    cancel: function() {
      this.$emit('cancel');
    },
    save: function() {
      var newImgs = [];
      for (var idx in this.imgs) {
        if (this.imgs[idx].id.startsWith('n-')) {
          newImgs.push(this.imgs[idx]);
        }
      }
      this.$emit('ok', newImgs, this.currentImg.id, this.deleteImgs);
    },
    selectImg: function(id) {
      this.currentImg = this.getCurrentImg(this.imgs, id);
    },
    getCurrentImg: function(imgs, id) {
      for (var idx in imgs) {
        if (imgs[idx].id == id) {
          return {
            id: id,
            src: imgs[idx].src,
          };
        }
      }
      console.error('no data for id [' + id + '] get default image!');
      for (var idx in imgs) {
        if (imgs[idx].id.startsWith('/imgs/')) {
          return {
            id: imgs[idx].id,
            src: imgs[idx].src,
          };
        }
      }
    },
    closeCrop: function() {
      this.crop.dialog = false;
    },
    addNewCrop: function(src, exif) {
      var id = 'n-' + new Date().getTime();
      this.imgs.unshift({ id: id, src: src });
      this.currentImg = this.getCurrentImg(this.imgs, id);
      this.crop.dialog = false;
    },
    startLoading: function() {
      this.loading = true;
    },
    stopLoading: function() {
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.c-cover-dialog {
  width: 100%;
  padding: 0px 20px 0px 30px;
}
.le-tbs .c-cover-dialog {
  display: flex;
  flex-direction: column;
  padding: 0;
}
.v-card__title {
  padding-right: 30px;
}
.c-count {
  font-size: 12px;
  color: #999999;
}
.c-count.err {
  color: #b71c1c;
}
.c-r {
  overflow: hidden;
  width: auto;
  padding-left: 10px;
}
.le-tbs .c-r {
  padding: 0 5px;
  width: 100%;
}
.le-tbs .imgs {
  margin: 0 auto;
}
.c-r .c-img-item {
  float: left;
  position: relative;
  width: 100px;
  height: 100px;
}
.c-r .c-img-item .c-inside {
  position: absolute;
  top: 9px;
  left: 9px;
  width: 80px;
  height: 80px;
  cursor: pointer;
  cursor: hand;
  box-shadow: 0px 0px 3px #999999;
  border-radius: 50%;
  box-sizing: content-box;
}
a.c-main-img {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  box-sizing: content-box;
}
.c-r .c-img-item:not(.selected) label {
  background-color: #999999;
  border: solid 1px #999999;
  cursor: pointer;
  cursor: hand;
}
.c-r .c-img-item.selected label {
  background-color: #1b5e20;
  border: solid 1px #1b5e20;
  cursor: default;
}
.c-r .c-img-item .c-inside img {
  width: 80px;
  height: 80px;
  box-sizing: content-box;
}
.c-img-item img:hover {
}
.c-filter {
  display: none;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  box-sizing: content-box;
  opacity: 0.2 !important;
}
a.c-main-img:hover .c-filter {
  animation-duration: 0.2s;
  animation-name: fade-in-02;
  display: block;
  opacity: 0.2 !important;
}

.c-checked {
  display: none;
  position: absolute;
  top: 42px !important;
  left: 38px !important;
  width: 50px !important;
  height: 50px !important;
  filter: drop-shadow(1px 1px 2px #aaaaaa) !important;
}
:not(.selected) .c-checked {
  animation-duration: 0.5s;
  animation-name: fade-out;
  display: none;
}
.selected .c-checked {
  animation-duration: 0.5s;
  animation-name: fade-in;
  display: block;
}

label a.c-del-a {
  position: absolute;
  top: 55px !important;
  left: 55px !important;
  width: 30px !important;
  height: 30px !important;
  border-radius: 50%;
  box-sizing: content-box;
  box-shadow: 1px 1px 2px #aaaaaa;
  opacity: 0.5;
}
.c-del {
  position: absolute;
  top: 0px !important;
  left: 0px !important;
  border-radius: 50%;
  box-sizing: content-box;
  width: 30px !important;
  height: 30px !important;
}
.c-filter-del {
  display: none;
  position: absolute;
  top: 0px !important;
  left: 0px !important;
  border-radius: 50%;
  box-sizing: content-box;
  width: 30px !important;
  height: 30px !important;
}
label:hover a.c-del-a {
  animation-duration: 0.2s;
  animation-name: fade-in-08;
  display: block;
}
label a.c-del-a:hover {
  transition: 0.2;
  display: block;
  opacity: 1;
  box-shadow: 0px 0px 4px #999999 !important;
}
.c-clear {
  clear: both;
}
.c-errmsg {
  margin-top: 15px;
  margin-left: 10px;
}
</style>
